import { useEffect, useState } from 'react';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { useSivReportListView } from './useSivReportListView';
import VersionHistory from 'src/components/common/VersionHistory';
import { useMonitoringVisitLog } from 'src/components/StartUp/studyLogs/MonitoringVisitLogs/useMonitoringVisitLog';
import { useSelectedAppInfo } from 'src/util/SelectedAppInfo';
import { DataTable } from '@pihealth/common-ui-library';
import { useUser } from 'src/components/hooks/useUser';
import { setSelectedRowData, setChckListCMPArr } from 'src/store/sivReport';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import staticData from '../../../resources/static.json';
import { archLevel } from 'src/data/config';
import { setMessage } from 'src/store/Message';
import { GridToolbarExport } from '@mui/x-data-grid-pro';
import moment from 'moment';


export default function SivReportListView() {
  const { userPreferedDateFormat, getPreferredDateTimeInLocal } = usePreferedDateFormat();
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const imvViewPageOpen = true;
  const [showVersionHistory, setShowVersionHistory] = useState(false);
  const [headerTitle, setHedertitle] = useState('');
  const [docId, setDocId] = useState('');
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const { preferences } = useUser();
  const dispatch = useAppDispatch();
  const { selectedAppSection } = useSelectedAppInfo();
  const [rows, setRows] = useState<any>([]);
  const {
    getAllSIVReports,
    getAllsivReportData,
    getAllsivReportIsError,
    getAllsivReportIsLoading,
    getAllsivReportIsSuccess
  } = useSivReportListView();
  useMonitoringVisitLog();

  useEffect(() => {
    getAllSIVReports({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application: process.env.REACT_APP_NAME,
      application_section: selectedAppSection,
      application_module_section: 'SIV REPORT'
    });
  }, [selectedCountry, studyId, selectedSite, imvViewPageOpen]);

  useEffect(() => {
    if (getAllsivReportIsSuccess) {
      if (getAllsivReportData && Array.isArray(getAllsivReportData)) {
        setRows(
          getAllsivReportData.map((item: any) => {
            return {
              ...item,
              updated_on: getPreferredDateTimeInLocal(item.updated_on),
              start_date: getPreferredDateTimeInLocal(item.start_date),
              major_version: Number(item.major_version).toFixed(1).toString()
            };
          })
        );
      }
    }
  }, [getAllsivReportIsError, getAllsivReportIsSuccess, getAllsivReportIsLoading]);

  const rowClick = (rowData: any) => {
    if (archLevel === 'site') {
      if (rowData?.major_version === '0.0') {
        dispatch(setMessage({ msgDetails: `${rowData.visit_name} not yet published`, severity: 'error' }));
      } else {
        dispatch(setSelectedRowData(rowData));
        dispatch(setChckListCMPArr('sivReportpage'));
      }
    } else {
      dispatch(setSelectedRowData(rowData));
      dispatch(setChckListCMPArr('sivReportpage'));
    }
  };
  const versionClick = (versionData: any) => {
    setHedertitle(versionData.visit_name);
    setDocId(versionData.tp_document_id);
    setShowVersionHistory(true);
  };
  const actions = {
    visit_name: (data: any) => {
      rowClick(data);
    },
    major_version: (data: any) => {
      versionClick(data);
    }
  };

  const definedCustomDatGridExport = (exportFields: any = {}) => {
    return (
      <GridToolbarExport
        csvOptions={{
          fileName: `SIV REPORT ${moment(new Date()).format(
            `${(userPreferedDateFormat.includes('/')
              ? userPreferedDateFormat.replaceAll('/', '_')
              : userPreferedDateFormat.replaceAll('-', '_')
            ).toUpperCase()} hh_mm A`
          )}`
        }}
      />
    );
  };
  return (
    <>
      <DataTable
        rows={rows}
        columns={staticData.sivReportlistView.dataTablecolumns}
        datePreference={preferences?.date_format ? preferences?.date_format : 'MM/dd/yyyy'}
        actions={actions}
        loading={getAllsivReportIsLoading}
        showDateAndTime
        hasDefinedDataGridToolbarExport
        definedGridToolbarExport={definedCustomDatGridExport}
      />
      {showVersionHistory ? (
        <VersionHistory
          openVersoinHistory={showVersionHistory}
          setOpenVersoinHistory={setShowVersionHistory}
          title={headerTitle}
          documentId={docId}
          auditModuleSection={'SIV REPORT'}
        />
      ) : (
        ''
      )}
    </>
  );
}
